import {
    secureDelete,
    secureGet,
    securePost,
    securePut,
} from "../../Config/ApiConfig";

/**
 * Get paginated list of tickets with search, filters, and sorting.
 */
export const getTickets = async ({ page, size, search, filters, sort_by, sort_direction, signal }) => {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("page_size", size);

    if (search && search.trim()) {
        params.append("search_string", search.trim());
    }

    if (filters && Object.keys(filters).length > 0) {
        // Flatten filters: for each key, set filters[key]=value
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(`filters[${key}]`, value);
            }
        });
    }

    if (sort_by) {
        params.append("sort_by", String(sort_by));
    }
    if (sort_direction) {
        params.append("sort_direction", String(sort_direction));
    }

    const { data } = await secureGet(`/tickets?${params.toString()}`, signal ? { signal } : {});
    return data;
};

/**
 * Get a single ticket by ID.
 */
export const getTicket = async (id) => {
    const { data } = await secureGet(`/tickets/${id}`);
    return data;
};

/**
 * Create a new ticket.
 */
export const createTicket = async (body) => {
    const { data } = await securePost('/tickets', body);
    return data;
};

/**
 * Update an existing ticket.
 */
export const updateTicket = async (id, body) => {
    const { data } = await securePut(`/tickets/${id}`, body);
    return data;
};

/**
 * Delete a ticket.
 */
export const deleteTicket = async (id) => {
    const { data } = await secureDelete(`/tickets/${id}`);
    return data;
};

/**
 * Get paginated comments for a ticket.
 */
export const getTicketComments = async ({ ticketId, page, size, sort_by, sort_direction }) => {
    const params = new URLSearchParams();
    params.append("page", page || 1);
    params.append("page_size", size || 25);

    if (sort_by) {
        params.append("sort_by", String(sort_by));
    }
    if (sort_direction) {
        params.append("sort_direction", String(sort_direction));
    }

    const { data } = await secureGet(`/tickets/${ticketId}/comments?${params.toString()}`);
    return data;
};

/**
 * Create a comment on a ticket.
 */
export const createTicketComment = async (ticketId, body) => {
    const { data } = await securePost(`/tickets/${ticketId}/comments`, body);
    return data;
};

/**
 * Update a ticket comment.
 */
export const updateTicketComment = async (commentId, body) => {
    const { data } = await securePut(`/tickets/comments/${commentId}`, body);
    return data;
};

/**
 * Delete a ticket comment.
 */
export const deleteTicketComment = async (commentId) => {
    const { data } = await secureDelete(`/tickets/comments/${commentId}`);
    return data;
};
